import axios from "axios";
import { host } from "../../helper/config";
import { getItemPerPage } from "../../helper/helper";

const PLUGINS_NAME = "admin-classic-return";

export const getReturnReasons = async (token) => {
  try {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/reasons`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("getReturnReasons error:", error);
    return null;
  }
};

export const addReturn = async (token, data) => {
  try {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("addReturn error:", error);
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return { success: false, message: "Lỗi kết nối" };
  }
};

export const getList = async (token, query, page, itemPerPage = getItemPerPage()) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/get-list`,
      {
        ...query,
        page: page,
        itemPerPage: itemPerPage,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("getList error:", error);
    return null;
  }
};

export const addBulkReturn = async (token, data) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/add-bulk`,
      data,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("addBulkReturn error:", error);
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return { success: false, message: "Lỗi kết nối" };
  }
};

export const getSummary = async (token, query) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/summary`,
      query,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("getSummary error:", error);
    return null;
  }
};
